import React, { useRef, useState, Component } from "react";
import HTMLFlipBook from "react-pageflip";
import "./FlipbookMainContent.css";
import WelcomeName from "../../function-components/WelcomeName";
import "./topicPageLeft.css";
import "./headerPart.css";
import "./TableOfContent.css";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Carousel from "react-bootstrap/Carousel";
import GenAIFlipbookData from "./GenAIFlipbookData.json";
import SapPDF from "../FlipbookContent/SAP-Innovation.pdf";

// Cover Page
const PageCover = React.forwardRef((props, ref) => {
  return (
    <div className="page page-cover" ref={ref} data-density="hard">
      <div className="contentWrapper">
        <img
          style={{ width: "100%" }}
          src="images/CoverPageUpdated.png"
          alt="CoverImage"
          className="coverImage"
        />
      </div>
    </div>
  );
});

// Table of Content
const PageTOCLeft = React.forwardRef((props, ref) => {
  return (
    <div className="page" ref={ref}>
      <div className="contentWrapper">
        <div className="tocContentContainer">{props.children}</div>
      </div>
    </div>
  );
});
const PageTOCRight = React.forwardRef((props, ref) => {
  return (
    <div className="page" ref={ref}>
      <div className="contentWrapper">
        <div className="tocContentContainer">{props.children}</div>
      </div>
    </div>
  );
});

// Page
const TopicPageLeft = React.forwardRef((props, ref) => {
  return (
    <div className="page page-cover" ref={ref}>
      <div className="contentWrapper">
        <div className="topicLeftContainer">
          {/* Topic Left Background Image */}
          <div className="topicLeftLeftImgContainer">
            <img
              src={props.LeftPageBgImage}
              alt=""
              className="topicLeftLeftImg"
            />
          </div>
          {/* Topic Right Text Container */}
          <div className="topicLeftRightContainer">
            <h5 className="topicLeftHeading">
              <span>{props.TopicCount} &nbsp;</span>
              <span style={{ marginLeft: "1%" }}>{props.TopicTitle}</span>
            </h5>
            <div className="topicLeftRightCardContainer">
              {/* Left Card */}
              <div className="topicLeftRightCard topicLeftRightCardLeft">
                {/* Left Card Top Icon */}
                <div className="topicLeftRightCardLeftTopIconContainer">
                  <img
                    src="images/topicAssets/Challenge.png"
                    alt="Challenges"
                    className="topicLeftRightCardLeftTopIcon"
                  />
                </div>
                {/* Left Card Text Container */}
                <div className="topicLeftRightCardLeftTextContainer">
                  <p className="topicLeftRightCardLeftTextHeading">Challenge</p>
                  <p className="topicLeftRightCardLeftTextP">
                    {props.Challenge}
                    <p className="topicLeftRightCardLeftTextP sublists">
                      {props.ChallengeSubchild}
                    </p>
                  </p>
                </div>
              </div>
              {/* Right Card */}
              <div className="topicLeftRightCard topicLeftRightCardsRight">
                {/* Right Card Top Icon */}
                <div className="topicLeftRightCardRightTopIconContainer">
                  <img
                    src="images/topicAssets/Solution.png"
                    alt="Challenges"
                    className="topicLeftRightCardLeftTopIcon"
                  />
                </div>
                {/* Right Card Text Container */}
                <div className="topicLeftRightCardLeftTextContainer">
                  <p className="topicLeftRightCardRightTextHeading">Solution</p>
                  <p className="topicLeftRightCardLeftTextP">
                    {props.Solution}
                  </p>
                  <p className="topicLeftRightCardLeftTextP sublists">
                    {props.Subchild}
                  </p>
                </div>
              </div>
            </div>
            <p className="topicPageNumbers">{props.PageNumber}</p>
          </div>
        </div>
      </div>
    </div>
  );
});
const TopicPageRight = React.forwardRef((props, ref) => {
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleOpen1 = () => setOpen1(true);
  const handleClose = () => setOpen(false);
  const handleClose1 = () => setOpen1(false);
  return (
    <div className="page page-cover" ref={ref}>
      <div className="contentWrapper">
        <div className="topicRightContainer">
          {/* Topic Right Page Header start*/}
          <div className="topicRightHeaderContainer">
            <p className="topicRightHeaderTextLeft">
              <span className="topicRightHeaderTextSpan">Industry:&nbsp;</span>
              {props.Industry}
            </p>
            <p className="topicRightHeaderTextRight">
              <span className="topicRightHeaderTextSpan">
                Domain/Function:{" "}
              </span>
              {props.Domain}
            </p>
          </div>
          {/* Topic Right Page Header end*/}
          <div className="topicRightTextContainer">
            {/* Topic Right Page Cards start */}
            <div className="topicRightPageLeftCardsContainer">
              {/* Left Card */}
              <div className="topicRightLeftCard topicRightLeftCardLeft">
                {/* Left Card Top Icon */}
                <div className="topicLeftRightCardLeftTopIconContainer">
                  <img
                    src="images/topicAssets/Key.png"
                    alt="Challenges"
                    className="topicLeftRightCardLeftTopIcon"
                  />
                </div>
                {/* Left Card Text Container */}
                <div className="topicLeftRightCardLeftTextContainer">
                  <p className="topicLeftRightCardLeftTextHeading">
                    Key Features
                  </p>
                  <p className="topicLeftRightCardLeftTextP">
                    {props.KeyFeatures}
                  </p>
                  <p className="topicLeftRightCardLeftTextP sublists">
                    {props.Keysubchild}
                  </p>
                </div>
              </div>
              {/* Right Page Right Yellow Card */}
              <div className="topicRightLeftCard topicRightLeftCardRight">
                {/* Right Card Top Icon */}
                <div className="topicLeftRightCardRightTopIconContainer">
                  <img
                    src="images/topicAssets/Outcomes.png"
                    alt="Challenges"
                    className="topicLeftRightCardLeftTopIcon"
                  />
                </div>
                {/* Right Card Text Container */}
                <div className="topicLeftRightCardLeftTextContainer">
                  <p className="topicLeftRightCardRightTextHeading">Outcomes</p>
                  <p className="topicLeftRightCardLeftTextP">
                    {props.Outcomes}
                  </p>
                  <p className="topicLeftRightCardLeftTextP sublists">
                    {props.Outcomechild1}
                  </p>
                  <p className="topicLeftRightCardLeftTextP">
                    {props.Outcomehead}
                  </p>
                  <p className="topicLeftRightCardLeftTextP sublists">
                    {props.Outcomechild2}
                  </p>
                </div>
              </div>
            </div>
            {/* Topic Right Page Thumbnails Container */}
            <div className="topicRightPageRightThumbnailContainer">
              <div className="topicRightPageRightThumbnailInnerWrap">
                <p className="topicRightPageRightThumbnailHeading">
                  *Click on thumbnail for details
                </p>

                <div className="topicRightPageRightThumbnailCardContainer">
                  {/* Thumbnail Images start */}
                  <div
                    className="topicRightPageRightThumbnailCard"
                    onClick={() => {
                      handleOpen();
                      props.BookRef.current.pageFlip().flipPrev();
                    }}
                  >
                    {props.ThmbnailImg}
                  </div>
                  <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <div className="modalDialogMainContainer">
                      {/* Modal Header */}
                      <div className="modalTopicTitleContainer">
                        {/* Modal Title */}
                        <div className="modalTopicTitle">
                          {props.TopicTitleRight}
                        </div>
                        {/* Modal Close Button */}
                        <button
                          className="thumbnailModalCloseButton"
                          onClick={handleClose}
                        >
                          <img
                            src="images/close.png"
                            alt="Close"
                            className="modalCloseButton"
                          />
                        </button>
                      </div>
                      {/* Modal Body */}
                      <div className="modalBodyContainer">
                        {props.BigThumbnailImg}
                        {/* <Carousel>
                        <Carousel.Item>
                          <div className="modalBodyImagesContainer">
                            <img
                              src="images/topicAssets/TopicOneA/1.jpg"
                              alt="One"
                              className="modalBodyImages"
                            />
                          </div>
                        </Carousel.Item>
                        <Carousel.Item>
                          <div className="modalBodyImagesContainer">
                            <img
                              src="images/topicAssets/TopicOneA/2.jpg"
                              alt="One"
                              className="modalBodyImages"
                            />
                          </div>
                        </Carousel.Item>
                        <Carousel.Item>
                          <div className="modalBodyImagesContainer">
                            <img
                              src="images/topicAssets/TopicOneA/3.jpg"
                              alt="One"
                              className="modalBodyImages"
                            />
                          </div>
                        </Carousel.Item>
                      </Carousel> */}
                      </div>
                    </div>
                  </Modal>
                  {/* Thumbnail Images End */}
                  {/* Thumbnail Video Start */}
                  {props.PageNumber == "36" ? (
                    <div></div>
                  ) : (
                    <div
                      className="topicRightPageRightThumbnailCardVideo"
                      onClick={() => {
                        handleOpen1();
                        props.BookRef.current.pageFlip().flipPrev();
                      }}
                    >
                      <p className="topicRightPageRightThumbnailCardVideoTextHeading">
                        {props.VideoThumbnailTitle}
                      </p>
                      <p className="topicRightPageRightThumbnailCardVideoTextSubheading">
                        *Click on the button to play the video
                      </p>
                      <img
                        src={props.VideoThumanailImg}
                        alt="Thumbnail Img"
                        className="topicRightPageRightThumbnailImages"
                      />
                    </div>
                  )}
                  {/* Thumbnail Video End */}
                  <Modal
                    open={open1}
                    onClose={handleClose1}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <div className="modalDialogMainContainer">
                      {/* Modal Header */}
                      <div className="modalTopicTitleContainer">
                        {/* Modal Title */}
                        <div className="modalTopicTitle">
                          {props.TopicTitleRight}
                        </div>
                        {/* Modal Close Button */}
                        <button
                          className="thumbnailModalCloseButton"
                          onClick={handleClose1}
                        >
                          <img
                            src="images/close.png"
                            alt="Close"
                            className="modalCloseButton"
                          />
                        </button>
                      </div>
                      {/* Modal Body */}
                      <div className="modalBodyContainer">
                        <iframe
                          id="kmsembed-1_143gggub"
                          style={{ marginTop: "30px" }}
                          width="900"
                          height="450"
                          src={props.VideoModalLink}
                          class="kmsembed"
                          allowfullscreen
                          webkitallowfullscreen
                          mozAllowFullScreen
                          allow="autoplay *; fullscreen *; encrypted-media *"
                          referrerPolicy="no-referrer-when-downgrade"
                          frameborder="0"
                          title="Collaborative SAP Applications with MSFT Teams"
                        ></iframe>
                      </div>
                    </div>
                  </Modal>
                  {/* Thumbnail Video End */}
                </div>
              </div>
            </div>
          </div>
          {/* Topic Right Page Cards end */}
        </div>
        <p className="topicPageNumbers">{props.PageNumber}</p>
      </div>
    </div>
  );
});

// Last Page
const LastPageCover = React.forwardRef((props, ref) => {
  return (
    <div className="page page-cover" ref={ref} data-density="hard">
      <div className="contentWrapper">
        <div className="lastPageContent">
          {/* Thank you card */}
          <div className="lastPageThankyouCardBorderContainer">
            <img
              src="images/lastPage/lastPageThank.png"
              alt="!"
              className="lastPageThankYouTextCard"
            />
          </div>
          {/* Contact Details */}
          <div className="lastPageContactDetailsContainer">
            <p className="lastPageContactDetailsText">
              <img
                src="images/lastPage/Email.png"
                alt=""
                className="lastPageContactDetailsMailIcon"
              />
              &nbsp; Contact for more details:{" "}
              <a
                href="mailto:SAP.InnovationHub.Blr@accenture.com"
                className="lastPageContactDetailsLinkForEmail"
              >
                SAP.InnovationHub.Blr@accenture.com
              </a>
            </p>
          </div>
          {/* All rights */}
          <div className="lastPageAllRightsContainer">
            <p className="lastPageAllRightsTextLeft">
              &copy;2023 Accenture. All Rights Reserved
            </p>
            <p className="lastPageAllRightsTextRIght">
              Conceptualized and Designed by Learning Integrated Services, LKM
            </p>
          </div>
        </div>
      </div>
    </div>
  );
});

function GenAIFlipbookMainContent() {
  const book = useRef();
  const [eventHandler, setEventHandler] = useState("");
  const [page, setPage] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const onFlip = (e) => {
    setPage(e.data);
    console.log(e.data);
    if (eventHandler !== "") {
      book.current.pageFlip().flip(page);
      setEventHandler("");
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      book.current.pageFlip().flip(parseInt(e.target.value));
      console.log(e);
    }
  };
  const handlepageChange = (e) => {
    const event = e.target.value;
    // const pageFlip = parseInt(event);
    setPage(event);
    // book.current.pageFlip().flip(parseInt(event))
    //  setPage(event);
    console.log(event);
    //  console.log(pageFlip);
    console.log(typeof event);
  };

  // Download PDF
  const downloadPDF = () => {
    // using Java Script method to get PDF file
    fetch(SapPDF).then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = SapPDF;
        alink.click();
      });
    });
  };

  return (
    <>
      <div>
        {/* Header Updated Start*/}
        <div className="headerWrapper">
          <div className="headerContainer">
            {/* Logo */}
            <div className="headerAccentureLogoLKMtextContainer">
              <div className="accentureLogoContainer">
                <img
                  src="images/Acc_Logo_Black_Purple_RGB.png"
                  alt="Accenture"
                  className="accentureLogo"
                />
                <p className="headerLkmText">SAP Innovations</p>
              </div>
            </div>
            {/* NavButtons */}
            <div className="headerNavButtonsWrapper">
              <div className="headerNavButtonsContainer">
                <div
                  className="headerNavButtonCon"
                  onClick={() => book.current.pageFlip().flip(1)}
                >
                  <img
                    src="images/header/toc.png"
                    alt=""
                    className="headerNavButton"
                  />
                </div>
                <div
                  className="headerNavButtonCon"
                  onClick={() => book.current.pageFlip().flipPrev()}
                >
                  <img
                    src="images/header/previous.png"
                    alt=""
                    className="headerNavButton"
                  />
                </div>
                {/* Page num */}
                <div className="headerNavPageNumberContainer">
                  <img
                    src="images/header/number.png"
                    alt=""
                    className="headerNavPageNumImg"
                  />
                  <p className="headerNavPageNumber">
                    <span>
                      <input
                        value={page}
                        pattern="^-?[0-9]\d*\.?\d*$"
                        onKeyPress={handleKeyDown}
                        onChange={handlepageChange}
                        className="headerPageNumberChange"
                      />
                    </span>
                    of 73
                  </p>
                </div>
                <div
                  className="headerNavButtonCon"
                  onClick={() => book.current.pageFlip().flipNext()}
                >
                  <img
                    src="images/header/next.png"
                    alt=""
                    className="headerNavButton"
                  />
                </div>
                <div onClick={downloadPDF} className="headerNavButtonCon">
                  <img
                    src="images/header/download.png"
                    alt=""
                    className="headerNavButton"
                  />
                </div>
              </div>
            </div>
            {/* Welcome Name */}
            <div className="headerWelcomeNameContainer">
              <p className="headerWelcomeName">
                <WelcomeName />
              </p>
              <img
                src="images/Avatar.png"
                alt="avatar"
                className="headerWelcomeNameAvatar"
              />
            </div>
          </div>
        </div>
        {/* Header Updated End */}
        <div className="FlipbookWrapper">
          <div style={{ width: "95%", margin: "auto", hight: "100vh" }}>
            <HTMLFlipBook
              width={350}
              height={320}
              size="stretch"
              maxShadowOpacity={0.15}
              autoSize={true}
              showCover={true}
              mobileScrollSupport={true}
              onFlip={onFlip}
              ref={book}
              drawShadow={true}
              className="FlipbookMainTag"
            >
              <PageCover></PageCover>
              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(8)}>
                      <img
                        src="images/TOC/Topic 01 updated.png"
                        alt="Collaborative Applications with MS Teams & SAP Enterprise (BTP)."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(10)}>
                      <img
                        src="images/TOC/Topic 02.png"
                        alt="stock Inentory Mangement"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(12)}>
                      <img
                        src="images/TOC/Topic 03.png"
                        alt="Supply Chain Mission Control"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(14)}>
                      <img
                        src="images/TOC/Topic 04.png"
                        alt="Self Healing App"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(16)}>
                      <img
                        src="images/TOC/Topic 05.png"
                        alt="SAP Build Apps"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    Sap Gen{" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      AI</span>
                  </p>
                </div>
              </PageTOCLeft>
              <PageTOCRight></PageTOCRight>

              {/* Page */}

               {GenAIFlipbookData.pages.map((item, index) => {
                if (item.pageNumber % 2 !== 0) {
                  return (
                    <TopicPageLeft
                      PageNumber={item.pageNumber}
                      TopicCount={item.topicCount}
                      TopicTitle={item.topicTitle}
                      LeftPageBgImage={item.leftPageBGImage}
                      Challenge={
                        <p>
                          {item.challenge.map((item1, index) => {
                            return <span>{item1}</span>;
                          })}
                        </p>
                      }
                      ChallengeSubchild={
                        <ul>
                          {item.challengeSubchild.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                      Solution={
                        <ul>
                          {item.solution.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                      Subchild={
                        <ul>
                          {item.subchild.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                    ></TopicPageLeft>
                  );
                } else {
                  return (
                    <TopicPageRight
                      BookRef={book}
                      PageNumber={item.pageNumber}
                      Industry={item.industry}
                      Domain={item.domain}
                      KeyFeatures={
                        <ul>
                          {item.keyFeatures.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                      Keysubchild={
                        <ul>
                          {item.keysubchild.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                      Outcomes={
                        <ul>
                          {item.outcomes.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                      Outcomechild1={
                        <ul>
                          {item.outcomechild1.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                      Outcomehead={
                        <ul>
                          {item.outcomehead.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                      Outcomechild2={
                        <ul>
                          {item.outcomechild2.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                      ThmbnailImg={
                        <>
                          {item.thmbnailImg.map((item1, index) => {
                            return (
                              <img
                                src={item1}
                                alt="Thumbnail Img"
                                className="topicRightPageRightThumbnailImages"
                              />
                            );
                          })}
                        </>
                      }
                      BigThumbnailImg={
                        <>
                          <Carousel>
                            {item.bigThumbnailImg.map((item1, index) => {
                              return (
                                <Carousel.Item>
                                  <div className="modalBodyImagesContainer">
                                    <img
                                      src={item1}
                                      alt="One"
                                      className="modalBodyImages"
                                    />
                                  </div>
                                </Carousel.Item>
                              );
                            })}
                          </Carousel>
                        </>
                      }
                      VideoThumbnailTitle={item.videoThumbnailTitle}
                      VideoThumanailImg={item.videoThumanailImg}
                      TopicTitleRight={item.topicTitleRight}
                      VideoModalLink={item.videoModalLink}
                    ></TopicPageRight>
                  );
                }
              })} 
              <LastPageCover></LastPageCover>
            </HTMLFlipBook>
          </div>
        </div>
      </div>
    </>
  );
}

export default GenAIFlipbookMainContent;
